// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y1Ba","newExpiryDate":"styles_newExpiryDate___Yg18","footer":"styles_footer__tQhAL"};